import React from "react";
import { useOutletContext } from "react-router-dom";
import SettingsSub from "../../components/Company/SettingsSub/SettingsSub";

const CompanySettingsSub = () => {
  const { page, setIsLoading, setPage, setIsModalOpen } = useOutletContext();

  return (
    <SettingsSub
      page={page} 
      setIsLoading={setIsLoading} 
      setPage={setPage} 
      setIsModalOpen={setIsModalOpen}
    />
  );
};

export default CompanySettingsSub;